// extracted by mini-css-extract-plugin
export var chevron = "_cf-4";
export var chevronExpanded = "_cf-5";
export var row = "_cf-0";
export var rowBody = "_cf-6";
export var rowDescription = "_cf-7";
export var rowHeader = "_cf-1";
export var rowTitle = "_cf-2";
export var rowTitleComplete = "_cf-3";